import { SET_COLORS, FETCH_COLORS } from "constants/ActionTypes";
import { INITIAL_STATE } from "constants/AppConstants";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COLORS:
      return {
        ...state,
        statusColors: action.payload
      };
    case SET_COLORS:
      return {
        ...state,
        statusColors: action.payload
      };
    default:
      return state;
  }
};
